'use client';
import { clientEnv, runtimeEnvironment } from '@/lib/env';

import { ClerkProvider } from '@clerk/nextjs';
import { clerkAppearance } from '@/lib/clerk-appearance';

const isDevBypass =
  runtimeEnvironment === 'development' &&
  clientEnv.NEXT_PUBLIC_DEV_AUTH_BYPASS === true;

const publishableKey = clientEnv.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY;

export function AuthProvider({ children }: { children: React.ReactNode }) {
  if (isDevBypass || !publishableKey) {
    return <>{children}</>;
  }

  return (
    <ClerkProvider
      publishableKey={publishableKey}
      afterSignOutUrl="/"
      localization={{
        signIn: {
          start: {
            title: 'Welcome back',
            subtitle: 'Sign in to your Eclipse Accounting workspace.',
          },
        },
        signUp: {
          start: {
            title: 'Create your account',
            subtitle: 'Start free. No card required.',
          },
        },
      }}
      appearance={{
        ...clerkAppearance,
        cssLayerName: 'clerk',
        options: {
          ...clerkAppearance.options,
          logoImageUrl: '/brand/eclipse_sun_gradient_asym.svg',
        },
      }}
    >
      {children}
    </ClerkProvider>
  );
}
